import {Component, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import { CasingPlan2dBaseComponent } from '../casing-plan-2d-base.component';
import { CasingPlanModel } from "../../../new-casing-plan/models/casing-plan.model";

@Component({
    selector: 'casing-plan-2d-schematic',
    templateUrl: './casing-plan-2d-schematic.component.html',
    styleUrls: ['./casing-plan-2d-schematic.component.scss'],
    standalone: false
})
export class CasingPlan2dSchematicComponent extends CasingPlan2dBaseComponent implements OnInit {
  @Input() direction: string;
  @Input() casingPlan: CasingPlanModel = null;
  @Input() applicationData: any = {};

  @ViewChild('canvas', {static: true}) canvasRef: ElementRef;


  totalNumberOfStrings: number;
  ctx: CanvasRenderingContext2D;
  canvasCenter: number;
  infoBoxSegmentOffset = 12;



  constructor() {
    super();
  }

    ngOnInit(): void {
     
    }

    //white background
    addWhiteBackground(canvasHeight?: number, canvasWidth?: number, ctx?: CanvasRenderingContext2D): void {
        //catch for directional schematic
        if (ctx) {
            this.ctx = ctx;
        }

        this.ctx.fillStyle = "#ffffff";
        if (!canvasHeight || !canvasWidth) {
            this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        } else {
            this.ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }
    }

/**
* Sets reusable variables
*/
  setVars(direction:string): void {
      this.totalNumberOfStrings = this.wellSegments.length;
      this.direction = direction;
      this.findLongestCasing();
      this.ctx = this.canvasRef.nativeElement.getContext('2d');
      this.canvasCenter = this.canvasWidth / 2;
  }
  haveSegmentData(): boolean {
      return this.wellSegments && this.wellSegments.length > 0;
  }
  /**
   * Returns proper (center) offset for a given casing string
   */
  getSegmentPosition(left: boolean): number {
      if (left) {
          return this.canvasCenter - this.getCasingPositionValue(this.segmentIndex + 1, true);
      } else {
          return this.canvasCenter + this.getCasingPositionValue(this.segmentIndex + 1, true);
      }
    }


    addSegmentLines(rightPosition: number, leftPosition: number, top: number, length: number, close: boolean): void {
        this.ctx.beginPath();
        this.ctx.moveTo(rightPosition, top);
        this.ctx.lineTo(rightPosition, length);
        this.ctx.stroke();
        if (close) {
            this.ctx.moveTo(rightPosition, length);
            this.ctx.lineTo(rightPosition - 20, length);
            this.ctx.stroke();
        }       
        this.ctx.moveTo(leftPosition, top);
        this.ctx.lineTo(leftPosition, length);
        this.ctx.stroke();
        if (close) {
            this.ctx.moveTo(leftPosition, length);
            this.ctx.lineTo(leftPosition + 20, length);
            this.ctx.stroke();
        }      
        this.ctx.closePath();
    }
  /**
* Draws filled filled casing strings
*/
  addSegment(segmentRightPosition, segmentLeftPosition, lineStart, length): void {
      this.ctx.beginPath();

      //add segments to calculated positions
      this.ctx.rect(segmentRightPosition, this.segmentIndex === 0 ? 0 : lineStart, this.segmentWidth, length);
      this.ctx.rect(segmentLeftPosition, this.segmentIndex === 0 ? 0 : lineStart, this.segmentWidth, length);

      //determine the fill color by the segment index
      this.ctx.fillStyle = "#888888";
      this.ctx.fill();
      this.ctx.closePath();
  }
  /**
   * Adds shoes to strings that aren't the final string
   */
  addShoes(segment, segmentRightPosition, segmentLeftPosition, lineStart, length): void {
      if (this.hasValidValue(segment.casingShoeDepth, 'number')) {
          this.ctx.beginPath();

          //calculate "fake" shoe position
          // shoes always go at bottom of the string (as of 2/19/19)
          let shoeY = lineStart + length - this.shoeHW;

          //add shoe
          this.addShoeToCanvas(this.ctx, shoeY, segmentRightPosition, segmentLeftPosition, true);

          this.ctx.closePath();
      }
  }

  /**
   * draws vertical lines to extend filled strings to the groud level
   */
  addUnfilledSegmentLines(segmentRightPosition, segmentLeftPosition, lineStart): void {
      this.ctx.beginPath();

      //right
      if (segmentRightPosition - this.segmentWidth > this.canvasCenter + this.segmentWidth) {
          this.ctx.moveTo(segmentRightPosition - this.segmentWidth, 0) //this.segmentIndex === 0 ? 0 : lineStart
          this.ctx.lineTo(segmentRightPosition - this.segmentWidth, lineStart + length);
      }

      if (segmentRightPosition > this.canvasCenter + this.segmentWidth) {
          this.ctx.moveTo(segmentRightPosition, 0)
          this.ctx.lineTo(segmentRightPosition, lineStart + length);
      }

      //left
      if (segmentLeftPosition + (2 * this.segmentWidth) <= this.canvasCenter - this.segmentWidth) {
          this.ctx.moveTo(segmentLeftPosition + (2 * this.segmentWidth), 0)
          this.ctx.lineTo(segmentLeftPosition + (2 * this.segmentWidth), lineStart + length);
      }

      if (segmentLeftPosition + this.segmentWidth <= this.canvasCenter - this.segmentWidth) {
          this.ctx.moveTo(segmentLeftPosition + this.segmentWidth, 0)
          this.ctx.lineTo(segmentLeftPosition + this.segmentWidth, lineStart + length);
      }

      this.ctx.stroke();
      this.ctx.closePath();
  }
  /**
   * Draws black ground rectangle at top of the diagram
   */
  addGround(): void {
      this.ctx.beginPath();
      this.ctx.rect(0, 0, this.canvasWidth, 3);
      this.ctx.fillStyle = "#191919";
      this.ctx.fill();
      this.ctx.closePath();
  }

  /**
   * This needs to be dynamic in the future
   */
  getInfoBoxHeight(casingType): number {
      return 26;
    }

    /**
     * Gets first kick point in all segments
     */
    getFirstSegmentKickpoint(): any {
        if (this.casingPlan && this.casingPlan.wellSegments) {
            for (let segment of this.casingPlan.wellSegments) {
                if (segment && segment.gisObjects) {
                    for (let gisObject of segment.gisObjects) {
                        if (gisObject.point == "Kick Point") {
                            return gisObject.tvd;
                        }
                    }
                }
            }
            return undefined;
        } else {
            return undefined;
        }
    }

    showError(error: string): void {
        this.ctx.beginPath();
        this.ctx.font = "18px 'Work Sans'";
        this.ctx.fillStyle = "#ff0000";
        this.ctx.textAlign = "center";
        this.ctx.fillText(error, this.canvasWidth * .5, this.canvasHeight * .5);
        this.ctx.closePath()
    }

}
